// extracted by mini-css-extract-plugin
export default {"light":"YBVpO0","dark":"BXf6_D","icon":"E_mpc3"};